import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { ShareIssueEditRoutes } from './Edit';
import { useShareIssueSuspenseQuery } from './ShareIssue.graphql';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useNavigate } from '../../components/Navigate';
import { ShareIssueShowWithRouter } from './ShowRouter';

export const ShareIssueRoutes = () => {
  const companyId = useCompanyId();
  const { pathname } = useNavigate();
  const { shareIssueId } = useParams<{ shareIssueId: string }>();

  const {
    data: { shareIssue, shareIssueErrors: errors },
  } = useShareIssueSuspenseQuery({ variables: { companyId, shareIssueId: shareIssueId! } });

  if (pathname.endsWith(shareIssue.id)) {
    const sirErrors = shareIssue.shareIssueRegistrations.at(0)!.validatorErrors;

    const editDone =
      ((errors.boardsStatement?.completed && !errors.boardsStatement?.hasError) ?? false) &&
      ((errors.decision?.completed && !errors.decision?.hasError) ?? false) &&
      ((errors.language?.completed && !errors.language?.hasError) ?? false) &&
      ((errors.payByOffset?.completed && !errors.payByOffset?.hasError) ?? false) &&
      ((errors.preferentialRights?.completed && !errors.preferentialRights?.hasError) ?? false) &&
      ((errors.subscriptionDate?.completed && !errors.subscriptionDate?.hasError) ?? false) &&
      ((errors.newShares?.completed && !errors.newShares?.hasError) ?? false) &&
      ((errors.shareClasses?.completed && !errors.shareClasses?.hasError) ?? false) &&
      ((sirErrors.currencyExchangeRate?.completed && !sirErrors.currencyExchangeRate?.hasError) ?? false);

    if (editDone) {
      return <Navigate to="show" replace />;
    }
    return <Navigate to="edit" replace />;
  }

  return (
    <Routes>
      <Route path="edit" element={<ShareIssueEditRoutes shareIssueId={shareIssueId!} />}>
        <Route path="*" element={<ShareIssueEditRoutes shareIssueId={shareIssueId!} />} />
      </Route>
      <Route path="show" element={<ShareIssueShowWithRouter shareIssueId={shareIssueId!} />}>
        <Route path="*" element={<ShareIssueEditRoutes shareIssueId={shareIssueId!} />} />
      </Route>
    </Routes>
  );
};
